import { render } from "./ChevronRight.vue?vue&type=template&id=6d4515c3"
import script from "./ChevronRight.vue?vue&type=script&lang=js"
export * from "./ChevronRight.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6d4515c3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d4515c3', script)) {
    api.reload('6d4515c3', script)
  }
  
  module.hot.accept("./ChevronRight.vue?vue&type=template&id=6d4515c3", () => {
    api.rerender('6d4515c3', render)
  })

}

script.__file = "src/icons/components/filled/ChevronRight.vue"

export default script